var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDoubleCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-doubleCheck"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-doubleCheck",
    clipPath: "url(#clip-icon-doubleCheck)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M688.871,961.129c-96.335,0-174.71-78.375-174.71-174.71S592.536,611.71,688.871,611.71s174.71,78.374,174.71,174.709S785.206,961.129,688.871,961.129Zm0-293.419a118.71,118.71,0,1,0,118.71,118.709A118.844,118.844,0,0,0,688.871,667.71Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M681.516,876.737a28,28,0,0,1-21.062-9.55l-51.871-59.221a28,28,0,1,1,42.125-36.9l29.68,33.885,54.24-68.774A28,28,0,0,1,778.6,770.855l-75.1,95.221a28,28,0,0,1-21.264,10.653Q681.877,876.737,681.516,876.737Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M516.613,959.581H231.807a73.082,73.082,0,0,1-73-73V137.355a73.082,73.082,0,0,1,73-73H790.581a73.083,73.083,0,0,1,73,73v479.9a28,28,0,0,1-56,0v-479.9a17.019,17.019,0,0,0-17-17H231.807a17.019,17.019,0,0,0-17,17V886.581a17.019,17.019,0,0,0,17,17H516.613a28,28,0,0,1,0,56Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M474.395,514.726H594.189q17.9,0,27.31,7.343t9.409,19.966a26.539,26.539,0,0,1-7.458,19.048q-7.46,7.8-22.605,7.8H431.938q-17.211,0-26.85-9.524t-9.639-22.376q0-8.261,6.2-21.917t13.54-21.457q30.518-31.67,55.078-54.275t35.112-29.719A202.642,202.642,0,0,0,536.7,382.882a106.293,106.293,0,0,0,19.048-27.539,65.473,65.473,0,0,0,6.541-27.654,49.846,49.846,0,0,0-7-26.277A48.542,48.542,0,0,0,536.242,283.4a55,55,0,0,0-26.276-6.426q-30.068,0-47.276,26.392-2.3,3.442-7.688,18.818t-12.163,23.638q-6.771,8.262-19.851,8.262-11.478,0-19.048-7.574t-7.573-20.654q0-15.836,7.114-33.047A94.717,94.717,0,0,1,424.709,261.6q14.115-14,35.8-22.6t50.833-8.606q35.112,0,59.9,11.016a90.214,90.214,0,0,1,28.228,20.2,94.781,94.781,0,0,1,25.7,64.717q0,28.459-14.113,51.751t-28.8,36.489q-14.689,13.2-49.227,41.423T485.64,499.808A130.052,130.052,0,0,0,474.395,514.726Z",
    fill: "#CF6B14"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleCheck);
export default __webpack_public_path__ + "static/media/icon-doubleCheck.a95ff6895b6577e1978dee22a37b7bc7.svg";
export { ForwardRef as ReactComponent };